/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-auditinglog-state';
import mutations from './module-auditinglog-mutations';
import actions from './module-auditinglog-actions';
import getters from './module-auditinglog-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
